import { FinanceEntryType } from "../typeDefs";

export const getBusinessUseRate = (entry: FinanceEntryType) => {
  if (typeof entry.businessUseRate === "number") return entry.businessUseRate;
  if (typeof entry.apportionRate === "number") return entry.apportionRate;
  return 100;
};

export const getFullTransactionAmount = (entry: FinanceEntryType) => {
  const businessUseRate = getBusinessUseRate(entry);

  if (typeof entry.originalAmount === "number" && entry.originalAmount > 0) {
    return entry.originalAmount;
  }

  // Some imported home-office/apportioned entries store only the business claim
  // as `amount`; reconstruct the full bank/card spend where possible.
  if (entry.isHomeOfficeExpense && businessUseRate > 0 && businessUseRate < 100) {
    return entry.amount / (businessUseRate / 100);
  }

  return entry.amount;
};

export const getPersonalApportionmentAmount = (entry: FinanceEntryType) => {
  if (!["Expenses", "Assets"].includes(entry.category)) return 0;

  // If the transaction was paid from a personal account and only the business
  // claim is being recorded in company accounts, the personal portion never
  // moved through the business and must not become shareholder drawings.
  if (entry.apportionmentSource === "Personal Account") return 0;

  const businessUseRate = getBusinessUseRate(entry);
  if (businessUseRate >= 100 || businessUseRate <= 0) return 0;

  const fullAmount = getFullTransactionAmount(entry);
  const businessAmount = entry.originalAmount ? entry.amount : fullAmount * (businessUseRate / 100);
  return Math.max(0, fullAmount - businessAmount);
};
